import { jsx as _jsx } from "react/jsx-runtime";
import { WidgetCard } from "@components/WidgetCard/WidgetCard";
import useDeIceData from "../hooks/useDeIceData";
export const DeIceMode = () => {
    const { data: deIceData } = useDeIceData();
    const deIceMode = deIceData && deIceData.deIceMode ? deIceData.deIceMode : "-";
    return _jsx(WidgetCard, { title: "De-ice Modus", children: deIceMode });
};
DeIceMode.displayName = "DeIceMode";
